import moment from "moment";

// JobApplication status codes — must match the backend seeder
// (supermedic-backend: database/seeders/JobApplicationStatusSeeder.php).
export const APP_STATUS = {
  PENDING: 0,
  PENDING_DOCTOR: 1,
  PENDING_PAYMENT: 2,
  APPROVED: 3,
  COMPLETED: 4,
  REJECTED: -1,
  CANCELLED: -2,
  DISPUTED: -3,
};

// True when the job's shift end time is in the past.
export const isJobEnded = (job) =>
  !!job?.end_timestamp && moment(job.end_timestamp).isBefore(moment());

// True when the worker has checked in (scanned the QR) for this job.
// The API exposes this per job via the `is_scanned` accessor (backend Doctor::getJobApplications).
export const isCheckedIn = (job) => job?.is_scanned === true;

// A checked-in job whose shift has ended is treated as completed for display,
// even before the backend cron promotes its status to COMPLETED (4).
export const isEffectivelyCompleted = (job) => {
  if (job?.job_application_status_code === APP_STATUS.COMPLETED) return true;
  return (
    isJobEnded(job) &&
    isCheckedIn(job) &&
    job?.job_application_status_code === APP_STATUS.APPROVED
  );
};

// "Expired" applies ONLY when the shift ended, the worker did NOT check in,
// and the application is not already completed or cancelled. A checked-in job
// is never "expired" — it is completed (or pending completion).
export const isApplicationExpired = (job) => {
  const code = job?.job_application_status_code;
  if (code === APP_STATUS.COMPLETED || code === APP_STATUS.CANCELLED) return false;
  if (!isJobEnded(job)) return false;
  if (isCheckedIn(job)) return false;
  return true;
};

// Canonical status consumed by Status.js / JobCard / history filters.
// Returns 4 (COMPLETED), the string "expired", or the raw backend status code.
export const deriveApplicationDisplayStatus = (job) => {
  if (isEffectivelyCompleted(job)) return APP_STATUS.COMPLETED;
  if (isApplicationExpired(job)) return "expired";
  return job?.job_application_status_code;
};
